module.exports = __webpack_public_path__ + "static/img/cj06.00fb9a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj06.png
// module id = 19
// module chunks = 0